// Who may mint a credential, as copy (#7426). The roles are the domain's
// `mintingRoles()` (`packages/domain/src/scopes.ts`, derived from the role
// ceiling), never a hand-typed pair: the day the ceiling moves, every sentence
// built on this moves with it. The labels are the members roster's own
// (`org_members.role_*`), joined the reader's way (`t.locale`).

import { mintingRoles } from '@developerz/domain';
import { t } from '../i18n';

/** "Owner, Admin or Member" — the roles that can mint, in the reader's locale. */
export function mintersLabel(): string {
  return new Intl.ListFormat(t.locale, { type: 'disjunction' }).format(
    mintingRoles().map((role) => t(`org_members.role_${role}`)),
  );
}
